import axios from "@/lib/axios";
import { QuestionnaireResultStatus } from "@/types/questionnaries";

export type GetPerformanceBenchmarkReportRequestParams = {
  companyId: string;
  editionId?: string;
  group?: "SECTOR" | "SUBSECTOR" | "REGIME";
};

export type GetPerformanceBenchmarkReportResponse = {
  result: {
    score: number;
    resultStatus: QuestionnaireResultStatus;
    color: string;
    dimensionResults: Array<{
      dimension: {
        dimension: string;
        group: string;
        order: number;
        name: string;
      };
      result: {
        score: number;
        scoreProportion: number;
        scorePercentage: number;
      };
    }>;
  };
  groupAverageResult: {
    score: number;
    resultStatus: QuestionnaireResultStatus;
    color: string;
    dimensionResults: Array<{
      dimension: {
        dimension: string;
        group: string;
        order: number;
        name: string;
      };
      result: {
        score: number;
        scoreProportion: number;
        scorePercentage: number;
      };
    }>;
  };
};

export const getPerformanceBenchmarkReport = (
  params: GetPerformanceBenchmarkReportRequestParams,
) =>
  axios
    .get<GetPerformanceBenchmarkReportResponse>(
      `/v1/companies/${params.companyId}/reports/questionnaires/performance-benchmark`,
      {
        params: {
          companyId: params.companyId,
          editionId: params.editionId,
          group: params.group,
        },
      },
    )
    .then((r) => r.data);
